import { produce } from "immer"

import DateFilter from "../../../components/DateFilter.tsx"

import MultiFilter from "./MultiFilter.tsx"

import type { Column } from "@tanstack/react-table"
import type { DateRange } from "react-day-picker"

export default function FilterDisplay<T, K extends keyof T>({
  column,
  label,
  displayFunc,
  variant,
}: {
  column: Column<T>
  label: string
  displayFunc: (v: T[K]) => React.ReactNode
  variant: "multi" | "date"
}) {
  const value = column.getFilterValue()
  const setValue = column.setFilterValue

  if (variant == "date") {
    let range: DateRange | undefined = undefined
    if (typeof value == "object" && value && "from" in value) {
      range = value as DateRange
    }

    const handleSelect = (v: DateRange | undefined) => {
      setValue(v)
    }

    return <DateFilter label={label} value={range} setValue={handleSelect} />
  } else {
    const handleSelect = (v: T[K], selected: boolean) => {
      if (selected) {
        if (Array.isArray(value)) {
          if (value.findIndex((x) => x == v) == -1) {
            setValue([...value, v])
          }
        } else {
          setValue([v])
        }
      } else {
        if (Array.isArray(value)) {
          const index = value.findIndex((x) => x == v)
          if (index != -1) {
            setValue(
              produce(value, (draft) => {
                draft.splice(index, 1)
              }),
            )
          }
        } else {
          setValue([])
        }
      }
    }

    return (
      <MultiFilter<T[K]>
        label={label}
        options={column.getFacetedUniqueValues().keys().toArray()}
        selected={value as T[K][]}
        setSelected={handleSelect}
        displayFunc={displayFunc}
      />
    )
  }
}
